/**
 * Replace a character at the index by the replacement.
 * @param string
 * @param index
 * @param replacement
 * @returns
 */
export function replaceAt(string: string, index: any, replacement: any) {
  const part1 = string.substring(0, index);
  const part2 = string.substring(index + 2);
  return part1 + replacement + part2;
}

/**
 * Check whether two strings are equal
 * when igoring casing.
 * @param a
 * @param b
 * @returns
 */
export function equalsCaseInsensitive(a?: string, b?: string) {
  return a?.toLowerCase() === b?.toLowerCase();
}

/**
 * Capitalizes the first letter
 * @param word
 * @returns
 */
export function capitalizeFirstLetter(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
